import './polyfill/polyfill-nodelist-foreach'
import './polyfill/polyfill-console'
import './polyfill/polyfill-custom-event'

import './tracking/ga4'
import './tracking/algolia'

import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import morph from '@alpinejs/morph'

Alpine.plugin(intersect)
Alpine.plugin(morph)

// alpine components (data) must be declared before Alpine.start

import './stores/session'
import './stores/wishlist'
import './component/header'
import './component/cookie-consent'
import './component/search-suggest'
import './component/add-to-wishlist'
import './component/login-form'
import './component/buy-now'
import './component/variant-select'
import './component/video-player'
import './component/product-sprite'
import './component/product-360'
import './component/product-media'
import './component/past-auctions'

document.addEventListener('alpine:init', () => {
    document.dispatchEvent(new Event('alpine:bundle'))
})

window.Alpine = Alpine
Alpine.start()

import './misc/legacy-link-decoder'
import './misc/overflow-y-hidden-jump-fix'